export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yesterday"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])}
}